import { useStudentMutation } from 'lib/apollo/student-apollo-hooks';
import { STUDENT_START_ASSIGNMENT } from '../assignment.graphql';
import type {
  StudentStartAssignmentMutation,
  StudentStartAssignmentMutationVariables,
} from '../assignment.graphql.generated';

type Props = {
  assignmentId: number;
  classId: number;
};

export const useStudentStartAssignmentMutation = ({
  assignmentId,
  classId,
}: Props) => {
  const [startAssignment, { loading }] = useStudentMutation<
    StudentStartAssignmentMutation,
    StudentStartAssignmentMutationVariables
  >(STUDENT_START_ASSIGNMENT, {
    variables: {
      input: {
        assignmentId,
        classId,
      },
    },
  });

  return {
    startAssignment,
    loading,
  };
};
